module.exports = __webpack_public_path__ + "static/media/credit_card.3cd51411.svg";